export default __webpack_public_path__ + "static/media/phone_icon.304a86e3.svg";